module.exports = __webpack_public_path__ + "media/88.95f6c0a7.wav";